import { render, staticRenderFns } from "./StudentAllShow.vue?vue&type=template&id=2801487f&scoped=true"
import script from "./StudentAllShow.vue?vue&type=script&lang=js"
export * from "./StudentAllShow.vue?vue&type=script&lang=js"
import style0 from "./StudentAllShow.vue?vue&type=style&index=0&id=2801487f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2801487f",
  null
  
)

export default component.exports